import { Outlet } from 'react-router-dom';
// hooks
// components
import { ThemeProvider } from '@mui/material/styles';
import { createCustomTheme } from 'src/theme/createCustomTheme';

// ----------------------------------------------------------------------

export default function SignUpWizardLayout({ children }: { children?: React.ReactNode }) {
  const customTheme = createCustomTheme('default');

  return (
    <ThemeProvider theme={customTheme}>
      <Outlet />

      {children}
    </ThemeProvider>
  );
}
